import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { NotificationType } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { EmailFrequency } from "../../../../api/graphql";
import { FormControl } from "@mui/material";

export type UserNotificationPreferenceViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  notificationTypeOptions: { id: string; displayId: string }[];
  notificationType: NotificationType;
  inAppEnabledValue?: { displayId: string; id: string } | null;
  inAppEnabled: boolean;
  emailEnabledValue?: { displayId: string; id: string } | null;
  emailEnabled: boolean;
  emailFrequencyOptions: { id: string; displayId: string }[];
  emailFrequency: EmailFrequency;
};

export const UserNotificationPreferenceViewForm: React.FC<UserNotificationPreferenceViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      notificationTypeOptions = [],
      notificationType = "" as NotificationType,
      inAppEnabled = false,
      emailEnabled = false,
      emailFrequencyOptions = [],
      emailFrequency = "" as EmailFrequency,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupUserNotificationPreferenceLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    notificationType
                      ? notificationTypeOptions.find(
                          (o: { id: string }) => o.id === notificationType
                        )?.displayId || notificationType
                      : ""
                  }
                  label={
                    langStore.UserNotificationPreferenceNotificationTypeLabel
                  }
                />
                <ShowBoolean
                  value={inAppEnabled}
                  label={langStore.UserNotificationPreferenceInAppEnabledLabel}
                />
                <ShowBoolean
                  value={emailEnabled}
                  label={langStore.UserNotificationPreferenceEmailEnabledLabel}
                />
                <ShowString
                  value={
                    emailFrequency
                      ? emailFrequencyOptions.find(
                          (o: { id: string }) => o.id === emailFrequency
                        )?.displayId || emailFrequency
                      : ""
                  }
                  label={
                    langStore.UserNotificationPreferenceEmailFrequencyLabel
                  }
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
